(function () {
  'use strict';

  var ZONE_KEYS = ['A', 'B', 'C', 'D', 'E', 'F'];

  function init(root) {
    if (root.dataset.tccInit === '1') return;
    var cfgEl = root.querySelector('script[type="application/json"][data-tcc-config]');
    var previewEl = root.querySelector('[data-tcc-preview]');
    var controlsEl = root.querySelector('[data-tcc-controls]');
    if (!cfgEl || !previewEl || !controlsEl) return;
    root.dataset.tccInit = '1';

    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) {
      console.error('TCC: failed to parse config JSON', e);
      return;
    }
    if (!cfg.svgUrl || !cfg.zones || !cfg.zones.length) return;

    var state = {};
    var svgEl = null;
    var appliqueLimit = parseInt(cfg.appliqueTextLimit, 10) || 0;
    var appliqueText = '';

    buildControls(cfg.zones, controlsEl, appliqueLimit, root.id || 'tcc');
    loadSvg(cfg.svgUrl, previewEl).then(function (svg) {
      svgEl = svg;
    }).catch(function (err) {
      console.error('TCC: failed to load SVG', err);
      previewEl.textContent = 'Unable to load design preview.';
    });

    controlsEl.addEventListener('change', function (e) {
      var sel = e.target.closest('select.tcc-select');
      if (!sel) return;
      var zone = sel.dataset.zone;
      var opt = sel.options[sel.selectedIndex];
      if (!opt || !opt.value) {
        delete state[zone];
        resetZone(svgEl, zone);
      } else {
        state[zone] = {
          code: opt.dataset.code,
          name: opt.dataset.name,
          hex: opt.dataset.hex
        };
        applyZone(svgEl, zone, opt.dataset.hex);
      }
      root.dispatchEvent(new CustomEvent('tcc:change', { bubbles: true, detail: Object.assign({}, state) }));
    });

    controlsEl.addEventListener('input', function (e) {
      var input = e.target.closest('input.tcc-text-input');
      if (!input) return;
      // maxlength doesn't cover all paste/programmatic cases — re-truncate
      if (appliqueLimit > 0 && input.value.length > appliqueLimit) {
        input.value = input.value.slice(0, appliqueLimit);
      }
      appliqueText = input.value;
      var count = controlsEl.querySelector('[data-tcc-text-count]');
      if (count) count.textContent = appliqueText.length + '/' + appliqueLimit;
      root.dispatchEvent(new CustomEvent('tcc:change', { bubbles: true, detail: Object.assign({}, state) }));
    });

    var api = {
      getSelections: function () { return Object.assign({}, state); },
      getZones: function () { return cfg.zones.slice(); },
      isComplete: function () {
        if (appliqueLimit > 0 && !appliqueText.trim()) return false;
        return cfg.zones.every(function (z) { return !!state[z.key]; });
      },
      isTextMissing: function () {
        return appliqueLimit > 0 && !appliqueText.trim();
      },
      getProperties: function () {
        var props = {};
        cfg.zones.forEach(function (z) {
          var sel = state[z.key];
          if (sel) {
            props['TrueColor - ' + z.key] = z.label + ' - ' + sel.code + ' - ' + sel.name;
          }
        });
        var text = appliqueText.trim();
        if (text) props['TrueColor Text'] = text;
        return props;
      },
      getPreviewDataUri: getPreviewDataUri,
      getPreviewBlob: getPreviewBlob
    };

    // Per-instance API lives on the root element (applique customizers).
    root.AWCTTrueColor = api;
    // Page-level singleton kept for back-compat — main customizer only
    // (block is limit:1; applique instances are marked data-tcc-applique).
    if (!root.hasAttribute('data-tcc-applique')) window.AWCTTrueColor = api;
    root.dispatchEvent(new CustomEvent('tcc:ready', { bubbles: true }));

    function getPreviewDataUri() {
      if (!svgEl) return '';
      try {
        var s = new XMLSerializer().serializeToString(svgEl);
        // UTF-8 safe base64
        return 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(s)));
      } catch (e) {
        console.warn('TCC: failed to serialize preview SVG', e);
        return '';
      }
    }

    // Rasterizes the colored preview to a PNG Blob (~600px wide) so the PQM
    // can upload it as a file line-item property instead of embedding a large
    // SVG data URI. Resolves null on any failure or after 3s — callers fall
    // back to getPreviewDataUri() and must never block ATC on this.
    function getPreviewBlob() {
      return new Promise(function (resolve) {
        var done = false;
        function finish(blob) {
          if (done) return;
          done = true;
          resolve(blob || null);
        }
        setTimeout(function () { finish(null); }, 3000);
        if (!svgEl) return finish(null);
        try {
          var clone = svgEl.cloneNode(true);
          var vb = (clone.getAttribute('viewBox') || '').split(/[\s,]+/);
          var w = 600;
          var h = 600;
          var vbW = parseFloat(vb[2]);
          var vbH = parseFloat(vb[3]);
          if (vbW > 0 && vbH > 0) h = Math.round(w * (vbH / vbW));
          // Firefox needs explicit dimensions on the SVG root for drawImage
          // (loadSvg strips width/height for responsive display).
          clone.setAttribute('width', w);
          clone.setAttribute('height', h);
          var s = new XMLSerializer().serializeToString(clone);
          var uri = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(s)));
          var img = new Image();
          img.onload = function () {
            try {
              var canvas = document.createElement('canvas');
              canvas.width = w;
              canvas.height = h;
              canvas.getContext('2d').drawImage(img, 0, 0, w, h);
              canvas.toBlob(finish, 'image/png');
            } catch (e) {
              console.warn('TCC: failed to rasterize preview', e);
              finish(null);
            }
          };
          img.onerror = function () { finish(null); };
          img.src = uri;
        } catch (e) {
          console.warn('TCC: failed to rasterize preview', e);
          finish(null);
        }
      });
    }
  }

  function buildControls(zones, mount, appliqueLimit, idPrefix) {
    var html = '';
    zones.forEach(function (z) {
      html += '<div class="tcc-row">';
      html += '<label class="tcc-label" for="' + esc(idPrefix) + '-select-' + esc(z.key) + '">';
      html += '<span class="tcc-zone-letter">' + esc(z.key) + '</span>';
      html += '<span class="tcc-zone-label">' + esc(z.label || '') + '</span>';
      html += '<span class="tcc-required" aria-hidden="true">*</span>';
      html += '</label>';
      html += '<select class="tcc-select" id="' + esc(idPrefix) + '-select-' + esc(z.key) + '" data-zone="' + esc(z.key) + '" required>';
      html += '<option value="">Options</option>';
      (z.colors || []).forEach(function (c) {
        html += '<option value="' + esc(String(c.code)) + '"'
          + ' data-hex="' + esc(c.hex) + '"'
          + ' data-name="' + esc(c.name) + '"'
          + ' data-code="' + esc(String(c.code)) + '">'
          + esc(String(c.code)) + ' - ' + esc(c.name)
          + '</option>';
      });
      html += '</select>';
      html += '</div>';
    });
    if (appliqueLimit > 0) {
      html += '<div class="tcc-row tcc-text-row">';
      html += '<label class="tcc-label" for="' + esc(idPrefix) + '-text-input">';
      html += '<span class="tcc-zone-label">Add Text</span>';
      html += '<span class="tcc-required" aria-hidden="true">*</span>';
      html += '</label>';
      html += '<div class="tcc-text-field">';
      html += '<input type="text" class="tcc-text-input" id="' + esc(idPrefix) + '-text-input"'
        + ' maxlength="' + appliqueLimit + '"'
        + ' placeholder="Up to ' + appliqueLimit + ' characters" required>';
      html += '<span class="tcc-text-count" data-tcc-text-count>0/' + appliqueLimit + '</span>';
      html += '</div>';
      html += '</div>';
    }
    mount.innerHTML = html;
  }

  function loadSvg(url, mount) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (text) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(text, 'image/svg+xml');
        var svg = doc.documentElement;
        if (!svg || svg.nodeName.toLowerCase() !== 'svg') {
          throw new Error('Response is not an SVG document');
        }
        svg.removeAttribute('width');
        svg.removeAttribute('height');
        svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
        mount.innerHTML = '';
        mount.appendChild(svg);
        return svg;
      });
  }

  function applyZone(svg, zoneKey, hex) {
    if (!svg || !zoneKey || !hex) return;
    if (ZONE_KEYS.indexOf(zoneKey) === -1) return;
    var group = svg.querySelector('#' + zoneKey);
    if (!group) return;
    group.querySelectorAll('path, polygon, polyline, rect, circle, ellipse').forEach(function (el) {
      el.setAttribute('fill', hex);
      el.style.fill = hex;
    });
  }

  function resetZone(svg, zoneKey) {
    if (!svg || !zoneKey) return;
    var group = svg.querySelector('#' + zoneKey);
    if (!group) return;
    group.querySelectorAll('path, polygon, polyline, rect, circle, ellipse').forEach(function (el) {
      el.removeAttribute('fill');
      el.style.fill = '';
    });
  }

  function esc(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function boot() {
    // Lazy roots (applique customizers) are initialized on demand via
    // window.AWCTTrueColorInit when their product is selected — booting
    // them here would fetch every applique SVG up front.
    document.querySelectorAll('[data-tcc-root]:not([data-tcc-lazy])').forEach(init);
  }

  // Entry point for lazy instances (idempotent via the init guard).
  window.AWCTTrueColorInit = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
